import * as React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { TreeView } from "@mui/x-tree-view/TreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DyLoadingCircular from "../DyLoadingCircular/DyLoadingCircular";
import { useSelector } from "react-redux";
import { useEffect, useState, useLayoutEffect } from "react";
import DYToastMessage from "../DyToastMessage/DYToastMessage";
import CircularProgress from "@mui/material/CircularProgress";
// import CustomDataGrid from './newTreeView';
import { IconButton } from "@mui/material";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import { Box } from "@mui/material";
import LyBackdrop from "../../Layouts/BackDrop/BackDrop";
import {
  useGetTeamsByTenantId,
  useGetAllObjectiveByTeamId,
  useGetAllTeamStatusByTenantId,
  useGetWebObjectiveDetailsCheckinMeetingByTeamId,
  useGetAllBAUsByTeamId
} from "../../../scenes/Meeting/Hooks/index";
import {
  updateObjR,
  resetTeamInfoR,
  setTeamsDataR,
  setTeamInfoR,
  changeTreeViewStateR,
} from "../../../scenes/Meeting/MeetingsSlice/MeetingsSlice";
import { useDispatch } from "react-redux";
import { NewUseStore } from "../../../Store/newUseStore";
import ArrowSVG from "../../svg/arrowSvg";

export default function DyTreeView({ setTabIndex , onClose  }: any) {
  const dispatch = useDispatch();
  const [rootsOfTree, setRootsOfTree] = useState([]);
  const teamsData: any = useSelector((state: any) => state.meetings.teamInfo);
  const companyNode: any = useSelector(
    (state: any) => state.meetings.companyList
  );
  // const teamList: any = useSelector((state: any) => state.meetings.teamList);
  const priodId: any = useSelector((state: any) => state.meetings.priodId);
  const meetingId: any = useSelector((state: any) => state.meetings.meetingId);
  const wholeCompanyTree: any = useSelector(
    (state: any) => state.meetings.wholeCompanyTree
  );

  //NADERI
  ////test
  // let wholeCompanyTree1 = { ...wholeCompanyTree };
  // (
  //   wholeCompanyTree1 as any
  // ).webTeamHaveParentCheckinMeetingDetailsQueryResultDtos[0].webTeamCheckinMeetingDetailsQueryResultDtos[3] =
  //   {
  //     ...(wholeCompanyTree1 as any)
  //       .webTeamHaveParentCheckinMeetingDetailsQueryResultDtos[0]
  //       .webTeamCheckinMeetingDetailsQueryResultDtos[3],
  //     webTeamCheckinMeetingDetailsQueryResultDtos: [
  //       {
  //         ...(wholeCompanyTree1 as any)
  //           .webTeamHaveParentCheckinMeetingDetailsQueryResultDtos[0]
  //           .webTeamCheckinMeetingDetailsQueryResultDtos[5],
  //       },
  //     ],
  //   };
  // let teamList1 = [...teamList];
  //   if (teamList1 && teamList1.length > 7) {
  //   teamList1[7] = { ...teamList1[7], parentId: teamList1[3].id };
  //   teamList1[8] = { ...teamList1[8], parentId: teamList1[7].id };
  //   teamList1[4] = { ...teamList1[4], parentId: teamList1[8].id };
  //   teamList1[2] = { ...teamList1[2], parentId: teamList1[4].id };
  //   teamList1[6] = { ...teamList1[6], parentId: teamList1[4].id };
  // }
  // console.log(wholeCompanyTree);
  ////
  const updateNewCompanyId = NewUseStore((state) => state.updateNewCompanyId);

  const [companys, setCompanys] = useState<any | null>([]);
  const [nodeId, setNodeId] = useState<any>(companys[0]?.id);
  const [teams, setTeams] = useState<any | null>([]);
  const [openTeams, setOpenTeams] = useState<string[]>([]);
  const openTeamsRef = React.useRef<string[]>(openTeams);

  useEffect(() => {
    if (companyNode) {
      let { id } = companyNode;
      // console.log(companyNode)
      setNodeId(id);
      dispatch(setTeamInfoR(companyNode));
    }
  }, []);

  useEffect(() => {
    const treeData =
      wholeCompanyTree &&
      (wholeCompanyTree as any)
        .webTeamHaveParentCheckinMeetingDetailsQueryResultDtos
        ? (wholeCompanyTree as any)
            .webTeamHaveParentCheckinMeetingDetailsQueryResultDtos
        : (wholeCompanyTree as any)
            .webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos &&
          (wholeCompanyTree as any)
            .webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos;

    setRootsOfTree(
      !treeData || (Array.isArray(treeData) && treeData.length === 0)
        ? null
        : treeData
    );
    if (
      wholeCompanyTree &&
      (wholeCompanyTree as any)
        .webTeamHaveParentCheckinMeetingDetailsQueryResultDtos &&
      (wholeCompanyTree as any)
        .webTeamHaveParentCheckinMeetingDetailsQueryResultDtos.length === 1
    ) {
      const rootId: string = (wholeCompanyTree as any)
        .webTeamHaveParentCheckinMeetingDetailsQueryResultDtos[0].id;
      let openTeamsLocal = [...openTeams];
      openTeamsLocal.push(rootId);
      setOpenTeams(openTeamsLocal);
      openTeamsRef.current.push(rootId);
    }
  }, [wholeCompanyTree]);

  const getObjectiveSuccess = () => {
    dispatch(updateObjR());
  };

  const getObjectiveError = () => {
    setToastMessage(true);
  };
  const {
    data,
    isError: getObjectiveErrorFlag,
    isLoading: getObjLoading,
  } = useGetWebObjectiveDetailsCheckinMeetingByTeamId(
    getObjectiveSuccess,
    getObjectiveError,
    nodeId,
    priodId,
    meetingId
  );

  // const {
  //   dataBAU,
  //   isError: getObjectiveErrorFlagBAU,
  //   isLoading: getObjLoadingBAU,
  // } = useGetAllBAUsByTeamId(
  //   getObjectiveSuccess,
  //   getObjectiveError,
  //   nodeId,
  //   priodId,
  //   meetingId
  // );

  const [renderContent, setRenderContent] = useState<any>("companyAndTeams");
  const [toastMessage, setToastMessage] = useState<any>(false);

  const initNodeSelected = (node: any, i: number) => {
    updateNewCompanyId(node.id);
    //Naderi Temp dispatch(setTeamsDataR(node));
    dispatch(setTeamInfoR(node));

    setNodeId(node.id);
  };
  const [treeViewVisible, setTreeViewVisible] = useState(true); // درخت به‌صورت پیش‌فرض باز است

  
  const toggleTreeView = () => {
    setTreeViewVisible((prev) => !prev); // تغییر وضعیت نمایش درخت
  };

  const setOpenCloseTeams = (node: any) => {
    let tempOpenTeams: string[] = [...openTeams];
    if (openTeams.findIndex((item: string) => item === node.id) > -1) {
      closeTeams(node);
      setOpenTeams(openTeamsRef.current);
    } else {
      tempOpenTeams.push(node.id);
      openTeamsRef.current = tempOpenTeams;
      setOpenTeams(tempOpenTeams);
    }
  };

  const closeTeams = (node: any) => {
    node.webTeamCheckinMeetingDetailsQueryResultDtos &&
      node.webTeamCheckinMeetingDetailsQueryResultDtos.map((item: any) =>
        closeTeams(item)
      );

    openTeamsRef.current = openTeamsRef.current.filter(
      (item: string) => item !== node.id
    );
  };
  const isTeamOpen = (Id: string) => {
    const state =
      openTeams.findIndex((item: string) => item === Id) > -1 ? true : false;
    return state;
  };

  const renderContentUi = () => {
    const ArrorClass =
      "w-4 text-slate-500 transition-all ease-in-out delay-150 duration-300 transform ";
    switch (renderContent) {
      case "companyAndTeams":
        return (
          <div className="flex flex-col cursor-pointer mr-2 text-sm font-bold mb-5 fontYekan h-[36rem] overflow-y-auto text-wrap ">
            <div className="flex flex-col cursor-pointer ">
              {rootsOfTree &&
                rootsOfTree.map((team: any, i: number) => (
                  <div key={i} className="flex flex-col cursor-pointer gap-y-1">
                    <div
                      className={`flex gap-x-2 ${
                        team.webTeamCheckinMeetingDetailsQueryResultDtos
                          ? "mr-1"
                          : "mr-5"
                      }  text-xs font-semibold cursor-pointer    
                      ${"max-h-6 opacity-100 mt-3 "}
                       transition-all ease-in-out delay-150 duration-300`}
                    >
                      {team.webTeamCheckinMeetingDetailsQueryResultDtos && (
                        <div
                          className="w-2 "
                          onClick={(e: any) => {
                            setOpenCloseTeams(team);
                          }}
                        >
                          <div
                            className={`${ArrorClass} ${
                              isTeamOpen(team.id) ? "-rotate-90" : "rotate-60"
                            } `}
                          >
                            <ArrowSVG />
                          </div>
                        </div>
                      )}
                      <div
                        className={`hover:text-slate-500 ${
                          team.id === nodeId
                            ? "text-[#F85700]"
                            : "text-black"
                        }`}
                        onClick={(e: any) => {
                          initNodeSelected(team, i);
                        }}
                      >
                        {team.name}
                      </div>
                    </div>
                    {team.webTeamCheckinMeetingDetailsQueryResultDtos &&
                      team.webTeamCheckinMeetingDetailsQueryResultDtos?.map(
                        (teamLevel2: any, iLevel2: number) => (
                          <div
                            key={iLevel2}
                            className="flex flex-col cursor-pointer mr-2 "
                          >
                            <div
                              className={`flex gap-x-2 ${
                                teamLevel2.webTeamCheckinMeetingDetailsQueryResultDtos
                                  ? "mr-2"
                                  : "mr-6"
                              } text-xs font-semibold cursor-pointer    ${
                                isTeamOpen(team.id)
                                  ? "max-h-6 opacity-100 mt-3 "
                                  : "max-h-0 opacity-0"
                              } transition-all ease-in-out delay-150 duration-300`}
                            >
                              {teamLevel2.webTeamCheckinMeetingDetailsQueryResultDtos && (
                                <div
                                  className="w-2 "
                                  onClick={(e: any) => {
                                    setOpenCloseTeams(teamLevel2);
                                  }}
                                >
                                  <div
                                    className={`${ArrorClass} ${
                                      isTeamOpen(teamLevel2.id)
                                        ? "-rotate-90"
                                        : "rotate-60"
                                    } `}
                                  >
                                    <ArrowSVG />
                                  </div>
                                </div>
                              )}
                              <div
                                className={`hover:text-slate-500 ${
                                  teamLevel2.id === nodeId
                                    ? "text-[#F85700]"
                                    : "text-black"
                                }`}
                                onClick={(e: any) => {
                                  initNodeSelected(teamLevel2, i);
                                }}
                              >
                                {teamLevel2.name}
                              </div>
                            </div>
                            {teamLevel2.webTeamCheckinMeetingDetailsQueryResultDtos &&
                              teamLevel2.webTeamCheckinMeetingDetailsQueryResultDtos?.map(
                                (teamLevel3: any, iLevel3: number) => (
                                  <div
                                    key={iLevel3}
                                    className="flex flex-col cursor-pointer mr-2 "
                                  >
                                    <div
                                      // className={`flex gap-x-2 ${
                                      //   teamLevel3.webTeamCheckinMeetingDetailsQueryResultDtos
                                      //     ? "mr-3"
                                      //     : "mr-7"
                                      // } text-xs font-semibold cursor-pointer    ${
                                      //   isTeamOpen(teamLevel2.id)
                                      //     ? "max-h-6 opacity-100 mt-3 "
                                      //     : "max-h-0 opacity-0"
                                      // } transition-all ease-in-out delay-150 duration-300`}
                                      className={`flex gap-x-2 ${
                                        teamLevel3.webTeamCheckinMeetingDetailsQueryResultDtos ? "mr-3" : "mr-7"
                                      } text-xs font-semibold cursor-pointer ${
                                        isTeamOpen(teamLevel2.id) ? "block mt-3" : "hidden"
                                      } transition-all ease-in-out delay-150 duration-300`}
                                      
                                    >
                                      {teamLevel3.webTeamCheckinMeetingDetailsQueryResultDtos && (
                                        <div
                                          className="w-2 "
                                          onClick={(e: any) => {
                                            setOpenCloseTeams(teamLevel3);
                                          }}
                                        >
                                          <div
                                            className={`${ArrorClass} ${
                                              isTeamOpen(teamLevel3.id)
                                                ? "-rotate-90"
                                                : "rotate-60"
                                            } `}
                                          >
                                            <ArrowSVG />
                                          </div>
                                        </div>
                                      )}
                                      <div
                                        className={`hover:text-slate-500 ${
                                          teamLevel3.id === nodeId
                                            ? "text-[#F85700]"
                                            : "text-black"
                                        }`}
                                        onClick={(e: any) => {
                                          initNodeSelected(teamLevel3, i);
                                        }}
                                      >
                                        {teamLevel3.name}
                                      </div>
                                    </div>
                                    {teamLevel3.webTeamCheckinMeetingDetailsQueryResultDtos &&
                                      teamLevel3.webTeamCheckinMeetingDetailsQueryResultDtos?.map(
                                        (teamLevel4: any, iLevel4: number) => (
                                          <div
                                            key={iLevel4}
                                            className="flex flex-col cursor-pointer mr-2 "
                                          >
                                            <div
                                              className={`flex gap-x-2 ${
                                                teamLevel4.webTeamCheckinMeetingDetailsQueryResultDtos
                                                  ? "mr-4"
                                                  : "mr-8"
                                              } text-xs font-semibold cursor-pointer    ${
                                                isTeamOpen(teamLevel3.id)
                                                  ? "max-h-6 opacity-100 mt-3 "
                                                  : "max-h-0 opacity-0"
                                              } transition-all ease-in-out delay-150 duration-300`}
                                            >
                                              {teamLevel4.webTeamCheckinMeetingDetailsQueryResultDtos && (
                                                <div
                                                  className="w-2 "
                                                  onClick={(e: any) => {
                                                    setOpenCloseTeams(
                                                      teamLevel4
                                                    );
                                                  }}
                                                >
                                                  <div
                                                    className={`${ArrorClass} ${
                                                      isTeamOpen(teamLevel4.id)
                                                        ? "-rotate-90"
                                                        : "rotate-60"
                                                    } `}
                                                  >
                                                    <ArrowSVG />
                                                  </div>
                                                </div>
                                              )}
                                              <div
                                                className={`hover:text-slate-500 ${
                                                  teamLevel4.id === nodeId
                                                    ? "text-[#F85700]"
                                                    : "text-black"
                                                }`}
                                                onClick={(e: any) => {
                                                  initNodeSelected(
                                                    teamLevel4,
                                                    i
                                                  );
                                                }}
                                              >
                                                {teamLevel4.name}
                                              </div>
                                            </div>
                                            {teamLevel4.webTeamCheckinMeetingDetailsQueryResultDtos &&
                                              teamLevel4.webTeamCheckinMeetingDetailsQueryResultDtos?.map(
                                                (
                                                  teamLevel5: any,
                                                  iLevel5: number
                                                ) => (
                                                  <div
                                                    key={iLevel5}
                                                    className="flex flex-col cursor-pointer mr-2 "
                                                  >
                                                    <div
                                                      className={`flex gap-x-2 mr-17 text-xs font-semibold cursor-pointer    ${
                                                        isTeamOpen(
                                                          teamLevel4.id
                                                        )
                                                          ? "max-h-6 opacity-100 mt-3 "
                                                          : "max-h-0 opacity-0"
                                                      } transition-all ease-in-out delay-150 duration-300`}
                                                    >
                                                      {teamLevel5.webTeamCheckinMeetingDetailsQueryResultDtos && (
                                                        <div
                                                          className="w-2 "
                                                          onClick={(e: any) => {
                                                            setOpenCloseTeams(
                                                              teamLevel5
                                                            );
                                                          }}
                                                        >
                                                          <div
                                                            className={`${ArrorClass} ${
                                                              isTeamOpen(
                                                                teamLevel5.id
                                                              )
                                                                ? "-rotate-90"
                                                                : "rotate-60"
                                                            } `}
                                                          >
                                                            <ArrowSVG />
                                                          </div>
                                                        </div>
                                                      )}
                                                      <div
                                                        className={`hover:text-slate-500 ${
                                                          teamLevel5.id === nodeId
                                                            ? "text-[#F85700]"
                                                            : "text-black"
                                                        }`}
                                                        onClick={(e: any) => {
                                                          initNodeSelected(
                                                            teamLevel5,
                                                            i
                                                          );
                                                        }}
                                                      >
                                                        {teamLevel5.name}
                                                      </div>
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                          </div>
                                        )
                                      )}
                                  </div>
                                )
                              )}
                          </div>
                        )
                      )}
                  </div>
                ))}
            </div>
          </div>
        );
        // <TreeView
        //   defaultExpanded={["0"]}
        //   aria-label="file system navigator"
        //   defaultCollapseIcon={<ArrowDropDownIcon fontSize="large" />}
        //   defaultExpandIcon={<ArrowLeftIcon fontSize="large" />}
        //   sx={{
        //     flexGrow: 0,
        //     maxWidth: 400,
        //     overflowY: "auto",
        //     minHeight: 50,
        //     py: 1,
        //   }}
        // >
        //   <TreeItem
        //     onClick={() => {
        //       // console.log(company)
        //       initNodeSelected(companyNode, 1);
        //       // console.log(company.id)
        //     }}
        //     nodeId={"0"}
        //     label={companyNode?.name}
        //   >
        //     {teamList1 &&
        //       teamList1?.map(
        //         (team: any, i: number) =>
        //           team.parentId === nodeId && (
        //             <TreeItem
        //               onClick={(e) => {
        //                 e.preventDefault();
        //                 initNodeSelected(team, i);
        //               }}
        //               key={i}
        //               sx={{ mt: 1, fontSize: "0.4rem !important" }}
        //               nodeId={team.id}
        //               label={team.name}
        //             >
        //               {teamList1.findIndex(
        //                 (item: any) => item.parentId === team.id
        //               ) > 0 &&
        //                 teamList1?.map(
        //                   (teamLevel2: any, iLevel2: number) =>
        //                     teamLevel2.parentId === team.id && (
        //                       <TreeItem
        //                         onClick={(e) => {
        //                           e.preventDefault();
        //                           initNodeSelected(teamLevel2, iLevel2);
        //                         }}
        //                         key={i}
        //                         sx={{ mt: 1, fontSize: "0.4rem !important" }}
        //                         nodeId={teamLevel2.id}
        //                         label={teamLevel2.name}
        //                       ></TreeItem>
        //                     )
        //                 )}
        //             </TreeItem>
        //           )
        //       )}
        //   </TreeItem>
        // </TreeView>

        // return  <TreeView

        // defaultExpanded={['0']}
        // aria-label="file system navigator"
        // defaultCollapseIcon={<ArrowDropDownIcon fontSize='large' />}
        // defaultExpandIcon={<ArrowLeftIcon fontSize='large' />}
        // sx={{ flexGrow: 1, maxWidth: 400, overflowY: 'auto',minHeight:800}}
        // >
        //   {
        //     companys && companys.map((company:any,i:number)=>{
        //       return <TreeItem

        //        key={i}
        //        onClick={()=>{
        //         // console.log(company)
        //         initNodeSelected(company,i)
        //         // console.log(company.id)

        //        }}
        //       nodeId={i.toString()}
        //       label={company.name} >
        //               {
        //                 teams && teams.map((team:any,i:number)=>{
        //                   return <TreeItem
        //                   onClick={()=>{

        //                     initNodeSelected(team,i)
        //                    }}
        //                   key={i}
        //                   sx={{mt:1,'& .rtl-305k3i-MuiTreeItem-content .MuiTreeItem-label':{fontSize:'0.7rem',fontWeight:800,py:1}}}
        //                   nodeId={team.id}
        //                   label={team.name}
        //                    />
        //                 })
        //               }
        //              </TreeItem>
        //     })
        //   }

        // </TreeView>

        break;

      case "teams":
        return (
          <TreeView
            // onNodeToggle={handleNodeToggle}
            defaultExpanded={["0"]}
            // defaultExpanded={teamsData?.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos[0]?.id}
            aria-label="file system navigator"
            defaultCollapseIcon={<ArrowDropDownIcon fontSize="large" />}
            defaultExpandIcon={<ArrowLeftIcon fontSize="large" />}
            sx={{
              flexGrow: 1,
              maxWidth: 400,
              overflowY: "auto",
              minHeight: 800,
            }}
          >
            {teams &&
              teams?.map((team: any, i: number) => {
                return (
                  <TreeItem
                    key={i}
                    onClick={() => {
                      // console.log(company)
                      initNodeSelected(team, i);
                    }}
                    nodeId={team.id}
                    label={team.name}
                  ></TreeItem>
                );
              })}
          </TreeView>
        );
        break;
    }
  };

  // if

  // if (getObjLoading) {
  //   return <LyBackdrop visible={true}  >
  //     <CircularProgress sx={{color:'white'}}  />
  //   </LyBackdrop>
  // }

  return (
    <Box sx={{ boxShadow: 1, borderRadius: 1, minHeight: 500 }}>
      {getObjLoading && (
        <LyBackdrop visible={true}>
          <CircularProgress sx={{ color: "white" }} />
        </LyBackdrop>
      )}

      <DYToastMessage show={toastMessage} setShow={setToastMessage} />

      <Box width={"100%"} height={"623px"}>
        {rootsOfTree && rootsOfTree.length  > 0 && (
          <Box width={"100%"} display={"flex"} flexDirection={"row-reverse"}>
            <IconButton onClick={onClose}>
              <ArrowCircleRightIcon />
            </IconButton>
          </Box>
        )}
        <div className="h-full w-full">{renderContentUi()}</div>
      </Box>
      {/* changeTreeViewStateR */}
    </Box>
  );
}
